module.exports = __webpack_public_path__ + "img/tile-med2.e8c1c015.jpg";